import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Row, Button, FormControl, ButtonGroup } from 'react-bootstrap'
import { Typeahead, AsyncTypeahead } from 'react-bootstrap-typeahead'
import axios from 'axios'
import {
  inputProjectLeads,
  inputAnalysts,
  inputProjectName,
  inputProjectRduids,
  inputStatus,
  inputRegulatoryRelated,
  changeProjectPage,
  changeProjectSortType,
  changeProjectView,
  inputMetadataFilters,
  clearMetadataFilters,
  myProjectSwitch,
  inputClients,
  clearAllProjectFilters,
  myDeliverablesSwitch
} from '../reducers/manageProjectFilters'
import { getUsers } from '../../login/reducers/manageLogin'
import NewProject from './project_creation/NewProject'
import ExportProject from './ExportProject'
import LoadingModal from '../../../reuseable-components/LoadingModal'
import getServerURL from "../../../functions/getServerURL";
import { handleErrorFetchingData } from "../../../functions/errorHandling";


class ProjectFilter extends Component {
  state = {
    open: false,
    showAdvancedFilters: this.props.metadataFilters.length > 0,
    downloadingProjects: false,
    fetchingRduids: false,
    rduids: [],
  }

  componentDidMount() {
    this.resetProjectPage()
    // this.getRDUIDs()
  }

  componentDidUpdate(prevProps, nextProps) {
    this.resetProjectPage()
  }

  getRDUIDs = () => {
    this.setState({ fetchingRduids: true }, () => {
      axios.get(`${getServerURL()}projects/get_all_rduids/`, {
        headers: {"Authorization": `Bearer ${localStorage.getItem("token")}`}
      }).then(response => {
        this.setState({ rduids: response.data, fetchingRduids: false })
      }).catch(error => {
        this.setState({ fetchingRduids: false })
        console.log(error, error.response)
        handleErrorFetchingData(error)
      })
    })
  }

  resetProjectPage = () => {
    /// THIS WILL TURN THE PAGE BACK TO 1 IF AFTER FILTERING THE PAGE
    /// OUTNUMBERS THE NUMBER OF FILTERED PROJECTS
    if (this.props.currentProjectPage > 1 && this.props.projects.length === 0) {
      this.props.changeProjectPage(1)
    }
  }

  toggleShowAdvancedFilters = () => {
    this.props.clearMetadataFilters()
    this.setState({ showAdvancedFilters: !this.state.showAdvancedFilters})
  }

  _renderMenuItemChildren = (user, props, index) => {
    // THIS METHOD ENABLES CUSTOM HIGHLIGHT FIELDS ON PROJECT LEAD/ANALYST TYPEAHEADS
    return [
      <div key="name" search={props.text}>
        <strong>{user.first_name} {user.last_name}</strong>
      </div>,
      <div key="population">
        <small>
          Email: {user.email ? user.email : "N/A"}
        </small>
      </div>,
    ]
  }

  renderAdvancedFilters = () => {
    return this.props.metadata.map(metadata => {
      const selected = this.props.metadataFilters.filter(value => value.metadata === metadata.url)

      const sortedMetadataOptions = metadata.metadata_values.sort((a, b) => {
        return a.value.localeCompare(b.value)
      })

      return (
        <div key={metadata.id}>
          <h5>{metadata.name}</h5>
          <Typeahead
            id={`${metadata.name.split(' ').join('')}Typeahead`}
            clearButton
            labelKey="value"
            multiple
            selected={selected}
            options={sortedMetadataOptions}
            placeholder={metadata.name}
            onChange={(metadataValues) => this.props.inputMetadataFilters(metadataValues, metadata.url)}
          />
        </div>
      )
    })
  }

  render () {
    // const { showAdvancedFilters } = this.state
    const users = this.props.users
    
    const filteredClients = this.props.clients.filter(client => client.managed_by_genesis)

    return (
      <Fragment>

        <LoadingModal
          show={this.state.downloadingProjects}
          text="Downloading projects data to Excel. This may take a few moments."
        />

        <div>
          <center className="activity-tracker">
            <span style={{textDecoration: 'underline'}}>
              Projects
            </span>
            <br/>
            <span>
              Active: {this.props.projectStatusCounts.active}
            </span>
            <br/>
            <span>
              On Hold: {this.props.projectStatusCounts.onHold}
            </span>
            <br/>
            <span>
              Not Started: {this.props.projectStatusCounts.notStarted}
            </span>
            <br/>
            <span>
              Completed: {this.props.projectStatusCounts.completed}
            </span>
          </center>

          <br/>

          {this.props.currentUser.is_manager ?
            <center>
                <div style={{display:"inline-block"}}>
                  <NewProject history={this.props.history} />
                </div>
              </center>
              :
              null
            }
        </div>

        <hr/>

        <center>
          <h3>View</h3>
        </center>
        <center>
          {this.props.deliverablesView ?
            <ButtonGroup className="my-project-filter-buttons">
              <Button
                active={this.props.myDeliverablesFilter}
                onClick={() => this.props.myDeliverablesSwitch(true)}
              >
                My Deliverables
              </Button>
              <Button
                active={!this.props.myDeliverablesFilter}
                onClick={() => this.props.myDeliverablesSwitch(false)}
              >
                All Deliverables
              </Button>
            </ButtonGroup>
            :
            <ButtonGroup className="my-project-filter-buttons">
              <Button
                active={this.props.myProjectsFilter}
                onClick={() => this.props.myProjectSwitch(true)}
              >
                My Projects
              </Button>
              <Button
                active={!this.props.myProjectsFilter}
                onClick={() => this.props.myProjectSwitch(false)}
              >
                All Projects
              </Button>
            </ButtonGroup>
          }
        </center>

        <center>
          <h3>Sort by</h3>
        </center>
        <div>
          {/* <h5>Sort Projects By</h5> */}
          <FormControl
            componentClass="select"
            placeholder="Sort Projects"
            onChange={(e) => this.props.changeProjectSortType(e.target.value)}
            value={this.props.projectSortType}
          >
            <option value="-created_date">Newest Project</option>
            <option value="-modified_date">Most Recent Change</option>
            <option value="status">Status</option>
            <option value="number">Project Number</option>
          </FormControl>
        </div>

        <center>
          <h3>Filter by</h3>
        </center>

        {
          this.props.projectLeadFilter.length
          || this.props.analystFilter.length
          || this.props.projectNameFilter.length
          || (this.props.projectRduidFilter && this.props.projectRduidFilter.length)
          || this.props.statusFilter.length
          || this.props.clientFilter.length
          || this.props.regulatoryRelatedFilter
            ?
          <center>
            <Button onClick={this.props.clearAllProjectFilters}>
              Clear All Filters
            </Button>
          </center>
          :
          null
        }

        <div>
          <h5>Client(s)</h5>
          <Typeahead
            id="ClientsFilterTypeahead"
            clearButton
            labelKey={client => `${client.name} ${client.short_code}`}
            multiple
            selected={this.props.clientFilter}
            options={filteredClients}
            placeholder="Client"
            onChange={this.props.inputClients}
            />
        </div>

        <div>
          <h5>Project Lead(s)</h5>
          <Typeahead
            id="ProjectLeadsFilterTypeahead"
            clearButton
            labelKey={user => `${user.first_name} ${user.last_name}`}
            multiple
            renderMenuItemChildren={this._renderMenuItemChildren}
            selected={this.props.projectLeadFilter}
            options={users}
            placeholder="Project Lead"
            onChange={this.props.inputProjectLeads}
            />
        </div>

        <div>
          <h5>Analyst(s)</h5>
          <Typeahead
            id="AnalystsFilterTypeahead"
            clearButton
            labelKey={user => `${user.first_name} ${user.last_name}`}
            multiple
            renderMenuItemChildren={this._renderMenuItemChildren}
            selected={this.props.analystFilter}
            options={users}
            placeholder="Analyst"
            onChange={this.props.inputAnalysts}
            />
        </div>

        <div>
          <h5>Project Status</h5>
          <Typeahead
            id="StatusFilterTypeahead"
            clearButton
            labelKey="name"
            multiple
            selected={this.props.statusFilter}
            options={["Active", "On Hold", "Not Started", "Completed"]}
            placeholder="Status"
            onChange={this.props.inputStatus}
            />
        </div>

        <div>
          <h5>Regulatory Related</h5>
          <Typeahead
            id="RegulatoryRelatedFilterTypeahead"
            clearButton
            labelKey="name"
            multiple
            selected={this.props.regulatoryRelatedFilter}
            options={["No", "Yes"]}
            placeholder="Regulatory Related"
            onChange={this.props.inputRegulatoryRelated}
            />
        </div>

        <div>
          <h5>RDUID</h5>
          {/*<Typeahead*/}
          {/*  id="RegulatoryRelatedFilterTypeahead"*/}
          {/*  clearButton*/}
          {/*  labelKey="name"*/}
          {/*  multiple*/}
          {/*  selected={this.props.projectRduidFilter}*/}
          {/*  options={ this.state.rduids }*/}
          {/*  placeholder="RDUIDs"*/}
          {/*  onChange={ this.props.inputProjectRduids }*/}
          {/*/>*/}
          <AsyncTypeahead
            id="async-example"
            multiple
            clearButton
            isLoading={ this.state.fetchingRduids }
            minLength={1}
            selected={ this.props.projectRduidFilter || [] }
            onChange={ this.props.inputProjectRduids }
            onSearch={ this.getRDUIDs }
            options={ this.state.rduids || [] }
            placeholder="Select RDUIDs"
          />
        </div>

        {/* <div id="AdvancedFilters">
          {showAdvancedFilters ?
            this.renderAdvancedFilters()
            :
            null
          }
          <br/>
          <center>
            <Button onClick={this.toggleShowAdvancedFilters}>
              {showAdvancedFilters ?
                'Hide and Remove Advanced Filters'
                :
                'Show Advanced Filters'
              }
            </Button>
          </center>
        </div> */}

        <div>
          <Row>
            <center>
              <br/>
              <ExportProject />
            </center>
          </Row>
        </div>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
    users: state.manageLogin.users,
    projects: state.manageProjects.projects,
    projectLeadFilter: state.manageProjectFilters.projectLeads,
    analystFilter: state.manageProjectFilters.analysts,
    projectNameFilter: state.manageProjectFilters.projectName,
    projectRduidFilter: state.manageProjectFilters.projectRduids,
    statusFilter: state.manageProjectFilters.status,
    regulatoryRelatedFilter: state.manageProjectFilters.regulatoryRelated,
    clientFilter: state.manageProjectFilters.clients,
    currentProjectPage: state.manageProjectFilters.currentProjectPage,
    projectSortType: state.manageProjectFilters.projectSortType,
    deliverablesView: state.manageProjectFilters.deliverablesView,
    listView: state.manageProjectFilters.listView,
    projectStatusCounts: state.manageProjects.projectStatusCounts,
    metadata: state.manageProjects.metadata,
    metadataFilters: state.manageProjectFilters.metadataFilters,
    myProjectsFilter: state.manageProjectFilters.myProjectsFilter,
    myDeliverablesFilter: state.manageProjectFilters.myDeliverablesFilter,
    currentDeliverablesPage: state.manageProjectFilters.currentDeliverablesPage,
    clients: state.manageLogin.clients,
  }
}

export default connect(mapStateToProps, { inputProjectLeads, inputAnalysts, inputProjectName, inputProjectRduids, inputStatus, inputRegulatoryRelated, getUsers, changeProjectPage, changeProjectSortType, changeProjectView, inputMetadataFilters, clearMetadataFilters, myProjectSwitch, inputClients, clearAllProjectFilters, myDeliverablesSwitch })(ProjectFilter);



// WEBPACK FOOTER //
// ./src/routes/projects/components/ProjectFilter.js